import React from "react";
import { useGlobalContext } from "./context/globalContext";

const Details = ({ project }) => {
  const { handleShowModal } = useGlobalContext();
  return (
    <section class="section shadow-sm lazyloaded" id="overview">
      <div class="over1">
        <h1 class="d-block section-heading color-primary text-capitalize">
          {project} - Overview
        </h1>

        <p>
          Welcome to Dosti Greenscapes, a luxurious residential enclave in Upper
          Camp, Pune, designed for modern, comfortable, and premium living.
          Spread across 12 acres, this high-rise township features 6.5 acres of
          podium-level amenities, giving residents the best of green spaces,
          leisure, and wellness. From spacious homes with ample sunlight to
          state-of-the-art security and lifestyle amenities, every element is
          designed to provide a seamless living experience. Located minutes from
          key business hubs, schools, hospitals, and retail destinations, Dosti
          Greenscapes offers an elite lifestyle in one of Pune’s fastest-growing
          neighborhoods.
        </p>
      </div>

      <center>
        <h3 style={{ fontSize: "1.2rem" }} className="mt-3">
          {project} - Highlights
        </h3>
      </center>

      <div
        className="mr0 aos-init aos-animate mt-2"
        data-aos="fade-up"
        data-aos-delay="600"
        data-aos-duration="3000"
      >
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy text-capitalize">
              <li>
                <span>750+ Trees planted in Dosti Greenscape</span>
              </li>
              <li>
                <span>Sprawling Greenery & Landscaped Gardens</span>
              </li>
              <li>
                <span>Outdoor Activites for Health Conscious Environment</span>
              </li>
              {/* <li>
                <span>20,000 Sqft of Clubhouse</span>
              </li> */}
            </ul>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy">
              <li>
                <span>Solar Panels for Hot Water</span>
              </li>
              <li>
                <span>Ramps for Elderly and Specially Abled</span>
              </li>
              <li>
                <span>Rain Water Harvesting</span>
              </li>
              {/* <li>
                <span>Excellent Social Infrastructure</span>
              </li> */}
            </ul>
          </div>
        </div>
      </div>
      <button
        class="chat-btn btn btn-info micro-form-btn effetMoveGradient enqModal download_brochure"
        onClick={handleShowModal}
      >
        <span class="d-inline-block mi mi-download mr-1 animated slideInDown infinite"></span>{" "}
        Download Brochure
      </button>
    </section>
  );
};

export default Details;
